import type { DailyCareHomeQueryParams } from '@/features/my-patient/services/use-query-daily-care-home';
import { createEnumObject } from '@/utils/create-enum-object';

export const VIEW_MODES = ['shift', 'overview'] as const;
export const VIEW_MODE = createEnumObject(VIEW_MODES);
export type ViewMode = (typeof VIEW_MODES)[number];

export const VIEW_TO_LAYOUT = {
  [VIEW_MODE.SHIFT]: 'SHIFT',
  [VIEW_MODE.OVERVIEW]: 'OVERVIEW',
} as const satisfies Record<string, DailyCareHomeQueryParams['layout']>;
